import HomeChatting from "../components/Home/HomeChatting/HomeChatting";
import HomeRooms from "../components/Home/HomeRooms/HomeRooms";
import HomeMembers from "../components/Home/HomeMembers/HomeMembers";
import HomeNotice from "../components/Home/HomeNotice/HomeNotice";
import HomeHeader from "../components/Home/HomeHeader";
import { useRecoilState } from "recoil";
import homeState from "../atoms/home";
import { useEffect } from "react";
import emitGetUsers from "../connector/emits/getUsers";
import emitGetMessages from "../connector/emits/getMessages";
import emitGetMyInfo from "../connector/emits/getMyInfo";

function Home() {
  const [home] = useRecoilState(homeState);

  useEffect(() => {
    emitGetMyInfo();
    emitGetUsers('square');
    emitGetMessages('square');
  }, []);

  return (
    <div>
      <HomeHeader />
      {
        {
          'chatting': <HomeChatting />,
          'rooms': <HomeRooms />,
          'members': <HomeMembers />,
          'notice': <HomeNotice />,
        }[home.menu]
      }
      
    </div>
  );
}

export default Home;
